import React from 'react';

export function InfoPopup({ isOpen, onClose }) {
    // If it's not open, render nothing
    if (!isOpen) return null;

    return (
        <div className="info-popup-backdrop" onClick={onClose}>
            <div className="info-popup-card" onClick={(e) => e.stopPropagation()}>
                <button type="button" className="info-popup-close" onClick={onClose}>
                    ✕
                </button>
                <h3 className="info-popup-title">Project Information</h3>
                <p className="info-popup-text">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since 1966, when designers at Letraset and James Mosley, the librarian at St Bride Printing Library in London, took a 1914 Cicero translation and scrambled it to make dummy text for Letraset's Body Type sheets. It has survived not only many decades, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised thanks to these sheets and more recently with desktop publishing software like Aldus PageMaker and Microsoft Word including versions of Lorem Ipsum.
					For more information, click <a href="https://www.luzern.ch/verwaltung/baudirektion/stadtentwicklung/planungsprojekte/tribschenstrasse" target="_blank" rel="noopener noreferrer">here</a>.
                </p>
            </div>
        </div>
    );
}